module.exports = __webpack_public_path__ + "img/57ef06f.jpg";